import React from 'react';
import { Navigate } from 'react-router-dom';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Alert from '@amzn/awsui-components-react/polaris/alert';
import { useAdminAuth } from '../../hooks';
import { AppLayout } from '../../components/Layout';
import MetricsOverview from './components/MetricsOverview';
import UsageChart from './components/UsageChart';
import TranscriptionMetrics from './components/TranscriptionMetrics';
import CostAnalytics from './components/CostAnalytics';
import UserAnalytics from './components/UserAnalytics';
import LanguageStats from './components/LanguageStats';

const analyticsBreadcrumbs = [
  { text: 'Home', href: '/' },
  { text: 'Analytics', href: '/analytics' }
];

const AnalyticsContent: React.FC = () => {
  const { isAdmin, email } = useAdminAuth();

  // Redirect non-admin users
  if (!isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <Container
      header={
        <Header
          variant="h1"
          description="Analytics dashboard for MediaCaption application metrics and insights"
        >
          Analytics Dashboard
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <Alert type="info">
          Welcome to the analytics dashboard, {email}. This page shows comprehensive metrics for the MediaCaption application.
        </Alert>

        <MetricsOverview />
        
        <SpaceBetween direction="horizontal" size="l">
          <UsageChart />
          <TranscriptionMetrics />
        </SpaceBetween>

        <SpaceBetween direction="horizontal" size="l">
          <CostAnalytics />
          <UserAnalytics />
        </SpaceBetween>

        <LanguageStats />
      </SpaceBetween>
    </Container>
  );
};

const AnalyticsDashboard: React.FC = () => {
  return (
    <AppLayout 
      content={<AnalyticsContent />}
      breadcrumbs={analyticsBreadcrumbs}
    />
  );
};

export default AnalyticsDashboard;
